/**
 * 首页面板的服务端API调用方法
 * @author luwei
 */

import { post } from '@/util/http'

/**
 * 获取当前登录用户的最近的安全审计列表，默认最近4条记录
 *
 * @return Result 结果对象
 */
export const selectRecently = () => post('/security/auditLog/selectRecently')

/**
 * 分页获取模糊查询列表
 *
 * @param pager
 *            通用查询分页对象
 * @param fuzzyText
 *            模糊查询字符串
 * @return Result
 */
export const selectPageOfMy = params =>
    post('/security/auditLog/selectPageOfMy', params)

/**
 * 获取我收到的最近4条通知
 *
 * @return Result 结果对象
 */
export const selectMyNotice = () => post('/common/notice/selectMyNotice')

/**
 * 标记当前用户已读该通知，即收到并已经阅读该通知
 *
 * @param noticeId 通知ID
 * @return Result 结果对象
 */
export const updateNoticeForRead = params =>
    post('/common/notice/updateForRead', params)

/**
 * 业务需要 - 查询登录用户可操作的机构权限
 *
 * @param
 * @return Result 结果对象
 */
export const getResidentOfficeTypes = params =>
    post('/org/residentOfficeSumUser/getResidentOfficeTypes', params)

/**
 * 分页获取模糊查询列表
 *
 * @param pager
 *            通用查询分页对象
 * @param fuzzyText
 *            模糊查询字符串
 * @return Result
 */
export const selectOrgList = params => post('/residentOffice/find', params)

export const selectResidentOfficeForIndexPage = params =>
    post('/residentOffice/dashboard', params)

/**
 * 首页-查询首席代表核雇员信息列表
 */
export const findPersonList = params =>
    post('/residentOffice/findPersonList', params)

/**
 * 字典信息导入
 */
export const exportCountryInfo = () => post('/country/export')

/**
 * 查询该用户是否需要修改密码
 *
 * @return Result
 */
export const findIsPasswordInvalid = params => post('/femsLogin/user/find/isPasswordInvalid', params)
